export default __webpack_public_path__ + "static/EYInterstateLight-919abcd6a2761425f49757c1e35b1bce.woff";